import Scene = Phaser.Scene;
import {AbstractNavPanel} from "@/scenes.ui/abstract-nav-panel";
import SpriteUtils from "@/utils/sprite-utils";

export default class ImageNavPanel extends AbstractNavPanel {

    private onChange!: (index: number) => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number,
                themes: string[], onChange: (index: number) => unknown) {
        super(scene, canvas, x, y, themes, 1);
        this.onChange = onChange;

        this.x = x;
        this.y = y;
    }

    protected makePanel(x: number, element: any): any {
        let self = this;
        let key = <string>element;
        const cont = this.scene.add.container(0, 0);
        const image = SpriteUtils.addImage(this.scene, 0, 0, key);
        cont.add(image);
        image.setDepth(1000);

        return cont;
    }

    protected onLeftPressed() {
        this.onChange(this.getCurrentStartIndex());
    }

    protected onRightPressed() {
        this.onChange(this.getCurrentStartIndex());
    }

    protected getButtonX(): number {
        return 150;
    }

    protected getButtonY(): number {
        return 0;
    }

    protected calculateCellWidth(creaturesAmount: number): number {
        return 140;
    }

}
